import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2a835c4d&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a835c4d')) {
      api.createRecord('2a835c4d', component.options)
    } else {
      api.reload('2a835c4d', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=2a835c4d&", function () {
      api.rerender('2a835c4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/invoices-active/Index.vue"
export default component.exports